var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconStreamSchedule = function SvgIconStreamSchedule(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#908CA0",
    fillRule: "evenodd",
    d: "M.205 11c0 5.953 4.842 10.795 10.795 10.795S21.794 16.953 21.794 11 16.953.206 11 .206a1.278 1.278 0 0 0-1.278 1.277v2.96a1.278 1.278 0 1 0 2.555 0V2.859c3.94.616 6.962 4.033 6.962 8.141 0 4.544-3.696 8.24-8.24 8.24-4.542 0-8.239-3.696-8.239-8.239a8.303 8.303 0 0 1 2.414-5.828 1.277 1.277 0 0 0-1.808-1.806A10.865 10.865 0 0 0 .205 11Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#908CA0",
    d: "m12.483 9.507-.024-.024-4.041-2.87a1.277 1.277 0 0 0-1.806 1.805l2.87 4.04.024.025a2.105 2.105 0 1 0 2.977-2.976Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconStreamSchedule);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-stream-schedule.1fb864819750d6c57730319a51f0e19f.svg";